module.exports = __webpack_public_path__ + "img/catalog-icon.c9de9b5b.svg";